import Dialog from '@/components/Dialog';
import styled from '@emotion/styled';

const LevelDialogContent = styled(Dialog.Content)({
  paddingBottom: 25,
  overflowX: 'hidden',
});

export default LevelDialogContent;
